import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Hunt } from '@cyborg-monorepo/hunter/common';
import { catchError, Observable, of, switchMap } from 'rxjs';
import { HuntService } from '../shared/services/hunt.service';

@Injectable()
export class ArchiveHuntGuard implements CanActivate {
  constructor(public router: Router, public huntService: HuntService) {}

  /**
   * Checks to see if a hunt is archived or not to determine if a user can access it
   */
  public canActivate(
    route: ActivatedRouteSnapshot,
  ): boolean | Observable<boolean> {
    return this.huntService.getHuntById(route.paramMap.get('id')).pipe(
      switchMap((hunt: Hunt) => {
        if (hunt.archived) {
          this.router.navigate(['hunt', 'archive-gate']);
          return of(false);
        } else {
          return of(true);
        }
      }),
      catchError(() => {
        return of(false);
      }),
    );
  }
}
